import React from 'react';
import { useState } from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import { ContentCopy, Check } from '@mui/icons-material';

type Props = {
    textToCopy: string;
    defaultLabel?: string;
    copiedLabel?: string;
    message?: string;
    sx?: object;
};

const CopyButton: React.FC<Props> = ({ 
    textToCopy, 
    defaultLabel = 'Copy', 
    copiedLabel = 'Copied!', 
    message = 'Copied to clipboard!', 
    sx 
}) => {
    const [isClicked, setIsClicked] = useState(false);

    const copy = async () => {
        try {
            if (!textToCopy) {
                throw new Error('There is no content to copy');
            }
            await navigator.clipboard.writeText(textToCopy);
            setIsClicked(true);

            toast.info(message, { position: 'top-right', theme: 'colored' });
            setTimeout(() => {
                setIsClicked(false);
            }, 5000);
        } catch (error) {
            console.error('Unable to copy to clipboard:', error);
        }
    };

    return (
        <Button
            onClick={copy}
            variant="contained"
            color="primary"
            sx={{
                ...sx,
                cursor: isClicked ? 'default' : 'pointer',
                pointerEvents: isClicked ? 'none' : 'auto',
            }}
        >
            {isClicked ? <Check sx={{ marginRight: '.25rem' }} /> : <ContentCopy sx={{ marginRight: '.25rem' }} />}
            {isClicked ? copiedLabel : defaultLabel}
        </Button>
    );
};

export default CopyButton;